// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"0824bc2d","977":"2c723718"}[chunkId] + ".chunk.js";
};